import style from "./PageButton.module.css";

import GrayBtn from "../button/GrayBtn";
import WhiteBtn from "../button/WhiteBtn";

import { Link } from "react-router-dom";
import PropTypes from "prop-types";

function PageButton(props) {
  const { passPath, nextPath } = props;
  return (
    <div className={style.buttonBox}>
      <Link to={passPath}>
        <WhiteBtn variant="h5" className={style.smallW}>
          略過
        </WhiteBtn>
      </Link>
      <Link to={nextPath}>
        <GrayBtn variant="h5" className={style.smallG}>
          下一頁
        </GrayBtn>
      </Link>
    </div>
  );
}

export default PageButton;
PageButton.propTypes = {
  passPath: PropTypes.string.isRequired,
  nextPath: PropTypes.string.isRequired,
};
